import React from 'react'
import ContextWrapper from './ContextWrapper'
import { useResume } from './ResumeProvider'
import { TranslationProvider } from '~/components/shared/TranslationProvider'
import translations from './locales.json'

const StandaloneViewer = ({ HideToolBar, locale = 'en', ...props }) => {
  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope={'javascript.components.ResumeBuilder'}
    >
      <ContextWrapper {...props}>
        <div id="resume-pdf-preview" className="relative md:flex-grow">
          <div className="w-full md:sticky md:left-0 md:top-0 md:h-screen">
            <PdfViewer HideToolBar={HideToolBar} />
          </div>
        </div>
      </ContextWrapper>
    </TranslationProvider>
  )
}
export default StandaloneViewer

const PdfViewer = ({ HideToolBar }) => {
  const {
    pdf: { url, loading },
  } = useResume()

  const viewerUrl = HideToolBar
    ? `${url}#toolbar=0&navpanes=0`
    : `${url}#navpanes=0`

  if (loading) {
    return null
  }
  return (
    <iframe
      src={viewerUrl}
      className="h-full w-full"
      title="Resume Preview"
      frameBorder="0"
      loading="lazy"
    />
  )
}
